import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { FullContainer } from '../../SharedComponents/FullContainer';
import { ActiveTabState, NavigationContainer } from '../../SharedComponents/MainPageWithNavigator/MainPageWithNavigator';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { EmailSettingsTab } from './EmailSettingsTab';
import { JoinedFamiliesTab } from './JoinedFamiliesTab';
import { ProfileTab } from './ProfileTab';

interface IProps {
    store: ApplicationStore;
}

interface IState {
    currentTabState: number;
}
@inject('store')
@observer
export class ProfileSettings extends React.Component<IProps & RouteComponentProps<any>, IState> {
    public state: IState = {
        currentTabState: 1
    };

    private renderSettingsTab(forState: number, title: string) {
        const isActive = forState === this.state.currentTabState;

        return (
            <div style={styles.tabContainer} onClick={() => this.setState({ currentTabState: forState })}>
                <p style={styles.titleText(isActive)}>{title}</p>
                {isActive && <div style={styles.focusBar} />}
            </div>
        );
    }

    public render() {
        return (
            <NavigationContainer
                {...this.props}
                activeTabState={ActiveTabState.PROFILE_SETTINGS}
                title={' '}
                middleTabs={{
                    state: 1,
                    render: (state: number) => {
                        return (
                            <div style={styles.settingsTabs}>
                                {this.renderSettingsTab(1, 'Profile')}
                                {this.renderSettingsTab(2, 'Joined Families')}
                                {this.renderSettingsTab(3, 'Notification Settings')}
                            </div>
                        );
                    }
                }}
            >
                <FullContainer>
                    {this.state.currentTabState === 1 && <ProfileTab />}
                    {this.state.currentTabState === 2 && <JoinedFamiliesTab />}
                    {this.state.currentTabState === 3 && <EmailSettingsTab />}
                </FullContainer>
            </NavigationContainer>
        );
    }
}

const styles = {
    settingsTabs: {
        display: 'flex',
        flex: 0.5,
        height: '100%',
        marginBottom: -20
    } as React.CSSProperties,
    focusBar: {
        height: 3,
        backgroundColor: '#24B1A8',
        width: '100%'
    },
    tabContainer: {
        display: 'flex',
        flex: 0.3333,
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between',
        cursor: 'pointer'
    } as React.CSSProperties,
    titleText: (isActive: boolean) => {
        return {
            width: '100%',
            fontWeight: isActive ? 900 : 400,
            opacity: isActive ? 0.8 : 0.5,
            fontSize: 18,
            textAlign: 'center',
            marginTop: 20,
            height: 30
        } as React.CSSProperties;
    }
};



// WEBPACK FOOTER //
// ./src/Pages/ProfileSettings/ProfileSettings.tsx